import { render, staticRenderFns } from "./ProfileNavbarTeacher.vue?vue&type=template&id=25097ef2&scoped=true"
import script from "./ProfileNavbarTeacher.vue?vue&type=script&lang=js"
export * from "./ProfileNavbarTeacher.vue?vue&type=script&lang=js"
import style0 from "./ProfileNavbarTeacher.vue?vue&type=style&index=0&id=25097ef2&prod&lang=css"
import style1 from "./ProfileNavbarTeacher.vue?vue&type=style&index=1&id=25097ef2&prod&lang=css&scoped=true"
import style2 from "./ProfileNavbarTeacher.vue?vue&type=style&index=2&id=25097ef2&prod&lang=css"
import style3 from "./ProfileNavbarTeacher.vue?vue&type=style&index=3&id=25097ef2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25097ef2",
  null
  
)

export default component.exports